module.exports = __webpack_public_path__ + "img/Ragnarok_Map.19a48334.png";